// vuex模块：工具方法
export default {
  state: {
    /**
     * 套餐菜已选菜品以id-specId为键值的对象
     * @param suitFood 套餐菜
     * @return {{}}
     */
    getSuitCartDetailsMapById: function (suitFood) {
      let details = {};
      for (let group of suitFood.foodSuitGroups) {
        for (let detailFood of group.cartDetails) {
          let key = detailFood.id + '-' + detailFood.specId;
          details[key] = detailFood;
        }
      }
      return details;
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/store.utils.js